<template>
  <div>
    <BaseTableSkeletonLoader v-if="isLoading"></BaseTableSkeletonLoader>

    <v-data-table
      v-else
      id="content-table"
      :dense="true"
      item-key="id"
      disableSort
      :headers="headers"
      :items="tableData"
      item-class="row-class"
      :disable-pagination="true"
      :mobile-breakpoint="0"
      :hide-default-header="true"
      :hide-default-footer="true"
      :class="{
        'table-layout-auto':
          (role.type === 'education_manager' ||
            ($vuetify.breakpoint.smAndUp && !showingDetailColumns)) &&
          allHidableHided
      }"
    >
      <template v-slot:top="">
        <div
          class="pa-3 sheet-info d-flex w-100 justify-space-between flex-column flex-sm-row"
          v-if="accountSheetData"
        >
          <div>
            <div class="d-flex align-baseline">
              <span class="text-h6">{{ accountSheetData.title }} </span>
              <span class="mr-2 text-body-2" small v-if="sheetStatusText">
                ({{ sheetStatusText }})
              </span>

              <v-menu v-if="isSuperOrAccountant">
                <template v-slot:activator="{ on }">
                  <v-btn text @click.stop="on.click" icon small>
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list class="px-2" dense>
                  <v-list-item @click.stop="viewHistory()">
                    <v-list-item-icon class="mr-3">
                      <v-icon small>mdi-note-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Xem lịch sử</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="!accountSheetData.isLock && isSuperOrAccountant"
                    @click.stop="onClickUpsertAccountSheet(accountSheetData)"
                  >
                    <v-list-item-icon class="mr-3">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Chỉnh sửa</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <template v-if="!accountSheetData.isLock && isSuperOrAccountant">
                    <v-list-item @click.stop="onClickDeleteAccountSheet(accountSheetData)">
                      <v-list-item-icon class="mr-3">
                        <v-icon small>mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Xóa</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-menu>
            </div>
            <div class="text-body-2">
              {{ dateRangeText }}
            </div>
            <div class="note text-body-2 mb-1">Kế toán phụ trách: {{ contactAccountantText }}</div>
            <div class="note text-body-2 mb-1" v-if="accountSheetData.note">
              {{ accountSheetData.note }}
            </div>
          </div>
          <div class="flex-fill"></div>
          <div class="d-flex justify-end">
            <div v-if="isSuperOrAccountant">
              <v-btn
                elevation="0"
                @click="onPublish"
                color="primary"
                v-if="!accountSheetData.isPublished"
                :loading="changingState"
              >
                Xuất bản
              </v-btn>
              <v-btn
                elevation="0"
                color="primary"
                v-else-if="!accountSheetData.isLock"
                :loading="changingState"
                @click="onLock"
              >
                Khóa
              </v-btn>
              <v-btn
                @click="onCancel"
                elevation="0"
                :loading="changingState"
                color="primary"
                v-else-if="!accountSheetData.isCanceled"
                >Thu hồi</v-btn
              >
            </div>
            <v-btn
              v-if="!accountSheetData.isLock && isSuperOrAccountant"
              icon
              class="ml-2"
              :loading="isRecalculating"
              @click="onClickRecalculateContent"
            >
              <v-icon> mdi-refresh </v-icon>
            </v-btn>
            <v-btn icon class="ml-2" :loading="exporting" @click="onClickExport">
              <v-icon> mdi-download </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex pa-3 align-center">
          <span class="text-body-2"> Total: {{ tableData.length }} </span>
          <div class="flex-fill"></div>
          <div style="width: 240px" v-if="isSuperOrAccountant">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              type="search"
              v-model="search"
              dense
              outlined
              hide-details="auto"
              clearable
            ></v-text-field>
          </div>
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" icon class="ml-2">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="px-2" dense>
              <v-list-item dense>
                <v-checkbox
                  class="mt-0"
                  hide-details="auto"
                  small
                  label="Chi tiết"
                  v-model="showingDetailColumns"
                ></v-checkbox>
              </v-list-item>
              <v-list-item dense v-for="(value, key) in headerVisibilityStatus" :key="key">
                <v-checkbox
                  class="mt-0"
                  hide-details="auto"
                  small
                  :label="value.text"
                  :input-value="value.show"
                  @change="onToggleHeader(key, !value.show)"
                ></v-checkbox
              ></v-list-item> </v-list
          ></v-menu>
        </div>
      </template>
      <!-- <template v-slot:item.slotCount="{ item }"> {{ getSlotCount(item) }} </template>
      <template v-slot:item.payCheck="{ item }">
        {{ getPayCheck(item) }}
      </template> -->
      <template v-slot:body.append="{ props, on }">
        <tr class="summary-row" v-if="isSuperOrAccountant">
          <td class="text-center orange" colspan="3">Tổng giảng phí</td>
          <td class="text-center">{{ totalSlotCount }}</td>
          <td class="text-center">
            {{ formatCurrency(totalCompensation) }}
          </td>
          <td class="text-center">
            {{ formatCurrency(totalPayCheck) }}
          </td>
          <td colspan="1000"></td></tr
      ></template>
      <template v-slot:header="{ props, on }">
        <thead>
          <tr>
            <th
              v-for="h in headerGroup1.filter(
                i => role.type !== 'education_manager' || !moneyRelatedColumns.includes(i.value)
              )"
              :class="h.class"
              v-show="h.show"
              :key="h.text"
              :style="{ textAlign: h.align || 'left' }"
              :rowspan="showingDetailColumns ? 2 : 1"
            >
              {{ h.text }}
            </th>
            <th v-if="showingDetailColumns" class="column-detail text-center" colspan="10">
              Chi tiết
            </th>
            <th
              v-for="h in headerGroup2"
              :class="h.class"
              v-show="h.show"
              :key="h.text"
              :style="{ textAlign: h.align || 'left' }"
              :rowspan="showingDetailColumns ? 2 : 1"
            >
              {{ h.text }}
            </th>
          </tr>
          <tr v-if="showingDetailColumns">
            <th
              v-for="h in headerGroup3"
              :class="h.class"
              :key="h.text"
              :style="{ textAlign: h.align || 'left' }"
              :colspan="h.value === 'slots' ? 3 : h.value === 'slotCount' ? 1 : 2"
            >
              {{ h.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ item }">
        <tr>
          <td
            :class="cell.class.replace('column', 'cell')"
            v-for="cell in headerGroup1.filter(
              i => role.type !== 'education_manager' || !moneyRelatedColumns.includes(i.value)
            )"
            :key="cell.value"
            :rowspan="showingDetailColumns ? item.account_sheet_rows.length : 1"
          >
            <div
              v-if="cell.value === 'compensation'"
              class="compensation-wrapper"
              @click="
                !accountSheetData.isLock && isSuperOrAccountant
                  ? onEditCompensation(item.id, item.compensation)
                  : undefined
              "
            >
              <v-btn
                v-if="!item.compensation && !accountSheetData.isLock && isSuperOrAccountant"
                icon
                small
              >
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
              <span v-else>
                {{ formatCurrency(item.compensation) }}
              </span>
            </div>
            <span v-else-if="cell.value === 'rate'">
              {{ formatCurrency(get(item, cell.value)) }}
            </span>
            <span v-else-if="cell.value === 'payCheck'">
              {{ formatCurrency(getPayCheck(item)) }}
            </span>
            <span v-else-if="cell.value === 'totalSlotCount'">
              {{ getSlotCount(item) }}
            </span>
            <span v-else>
              {{ get(item, cell.value) }}
            </span>
          </td>
          <!-- <td class="cell-rate" :rowspan="item.account_sheet_rows.length">
            {{ formatCurrency(item.rate) }}
          </td> -->
          <template v-if="showingDetailColumns">
            <td colspan="2" class="cell-course">
              {{ getCourseLabel(item.account_sheet_rows[0].class.course) }}
            </td>
            <td colspan="2" class="cell-class">
              <a :href="`/class/${item.account_sheet_rows[0].class.id}`">
                {{ item.account_sheet_rows[0].class.code }}
              </a>
            </td>
            <td class="cell-slot-count">
              {{ item.account_sheet_rows[0].slots.length }}
            </td>
            <td colspan="3" class="cell-slots">
              <div :key="slot.id" v-for="slot in item.account_sheet_rows[0].slots">
                {{ formatSlotLabel(slot.startTime, slot.endTime) }}&nbsp;
              </div>
            </td>

            <!-- <td class="cell-paycheck" :rowspan="item.account_sheet_rows.length">
          </td> -->
            <!-- <template v-if="accountSheetData.isPublished"> -->
            <td class="cell-note" colspan="2">
              <div
                class="note-wrapper"
                @click="
                  !accountSheetData.isLock && isSuperOrAccountant
                    ? onEditRowNote(item.account_sheet_rows[0].id, item.account_sheet_rows[0].note)
                    : undefined
                "
              >
                <v-btn
                  v-if="
                    !item.account_sheet_rows[0].note &&
                    !accountSheetData.isLock &&
                    isSuperOrAccountant
                  "
                  icon
                  small
                >
                  <v-icon small> mdi-pencil </v-icon>
                </v-btn>
                <span v-else>
                  {{ item.account_sheet_rows[0].note }}
                </span>
              </div>
            </td>
          </template>

          <td
            v-for="cell in headerGroup2"
            :key="cell.value"
            :rowspan="showingDetailColumns ? item.account_sheet_rows.length : 1"
            v-show="
              !hidableColumns.includes(cell.value) ||
              !!(headerVisibilityStatus[cell.value] || {}).show
            "
            :class="cell.class.replace('column', 'cell')"
          >
            <img
              @click="onClickQrcode((item.teacher.qrcode || {}).url)"
              v-if="cell.value === 'teacher.qrcode.url' && item.teacher.qrcode"
              class="qrcode-img"
              :src="getImgUrl(item.teacher.qrcode.url)"
              :alt="`QR code của ${item.teacher.name}`"
            />
            <span v-else>
              {{ get(item, cell.value) }}
            </span>
          </td>
          <!-- <td class="cell-confirmation">
              <v-simple-checkbox
                :disabled="accountSheetData.isLock"
                :value="item.slots[0].confirmation"
                @input="changeConfirmation(item.slots[0].id, !item.slots[0].confirmation)"
              >
              </v-simple-checkbox>
            </td> -->
          <!-- </template> -->
        </tr>
        <template v-if="showingDetailColumns && item.account_sheet_rows.length > 1">
          <tr
            class="child-row"
            v-for="i in item.account_sheet_rows.length - 1"
            :key="item.teacher.id + item.account_sheet_rows[i].class.id"
            :id="item.teacher.id + '_' + item.account_sheet_rows[i].class.id + '_' + i"
          >
            <td colspan="2" class="cellc-course">
              {{ getCourseLabel(item.account_sheet_rows[i].class.course) }}
            </td>
            <td colspan="2" class="cell-class">
              <a :href="`/class/${item.account_sheet_rows[i].class.id}`">
                {{ item.account_sheet_rows[i].class.code }}
              </a>
            </td>
            <td class="cell-slot-count">
              {{ item.account_sheet_rows[i].slots.length }}
            </td>
            <td colspan="3">
              <div :key="slot.id" v-for="slot in item.account_sheet_rows[i].slots">
                {{ formatSlotLabel(slot.startTime, slot.endTime) }}&nbsp;
              </div>
            </td>
            <!-- <template v-if="accountSheetData.isPublished"> -->
            <td class="cell-note" colspan="2">
              <div
                class="note-wrapper"
                @click="
                  !accountSheetData.isLock && isSuperOrAccountant
                    ? onEditRowNote(item.account_sheet_rows[i].id, item.account_sheet_rows[i].note)
                    : undefined
                "
              >
                <v-btn
                  v-if="
                    !item.account_sheet_rows[i].note &&
                    !accountSheetData.isLock &&
                    isSuperOrAccountant
                  "
                  icon
                  small
                >
                  <v-icon small> mdi-pencil </v-icon>
                </v-btn>
                <span v-else>
                  {{ item.account_sheet_rows[i].note }}
                </span>
              </div>
            </td>
            <!-- <td class="cell-confirmation">
                <v-simple-checkbox
                  :disabled="accountSheetData.isLock"
                  :value="item.slots[i].confirmation"
                  @input="changeConfirmation(item.slots[i].id, !item.slots[i].confirmation)"
                >
                </v-simple-checkbox>
              </td> -->
            <!-- </template> -->
          </tr>
        </template>
      </template>
    </v-data-table>

    <BaseDialog
      v-if="upsertAccountSheetDialog.isOpen"
      :isOpen="upsertAccountSheetDialog.isOpen"
      :title="upsertAccountSheetDialog.title"
      @close="upsertAccountSheetDialog.isOpen = false"
      @cancel="upsertAccountSheetDialog.onCancel"
      @confirm="upsertAccountSheetDialog.callback"
      :isSubmitting="upsertAccountSheetDialog.loading"
    >
      <v-form lazy-validation ref="upsertAccountSheetDialog">
        <v-card-text>
          <v-text-field
            autofocus
            label="Tiêu đề"
            v-model="upsertAccountSheetDialog.currentItem.title"
            :rules="[$rules.required]"
          ></v-text-field>
          <v-autocomplete
            :rules="[$rules.required]"
            v-model="upsertAccountSheetDialog.currentItem.accountant"
            item-text="name"
            :items="accountants"
            return-object
            item-value="id"
            label="Kế toán phụ trách"
            required
            dense
            outlined
            @change="onCourseChange"
          ></v-autocomplete>
          <template v-if="!accountSheetData.isLock">
            <date-selector
              label="Bắt đầu"
              :rules="[$rules.required]"
              :date="transformDateForDatePicker(upsertAccountSheetDialog.currentItem.startDate)"
              @change="onStartDateChange"
            ></date-selector>
            <date-selector
              label="Kết thúc"
              :rules="[$rules.required]"
              :date="transformDateForDatePicker(upsertAccountSheetDialog.currentItem.endDate)"
              @change="onEndDateChange"
            ></date-selector>
          </template>

          <v-textarea
            rows="3"
            label="Ghi chú"
            v-model="upsertAccountSheetDialog.currentItem.note"
          ></v-textarea
        ></v-card-text>
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="noteDialog.isOpen"
      :isOpen="noteDialog.isOpen"
      :title="noteDialog.title"
      @close="noteDialog.isOpen = false"
      @cancel="noteDialog.onCancel"
      @confirm="noteDialog.callback"
    >
      <v-form lazy-validation ref="noteDialog">
        <v-card-text> <v-textarea v-model="noteDialog.currentItem.note"></v-textarea></v-card-text>
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="compensationDialog.isOpen"
      :isOpen="compensationDialog.isOpen"
      :title="compensationDialog.title"
      @close="compensationDialog.isOpen = false"
      @cancel="compensationDialog.onCancel"
      @confirm="compensationDialog.callback"
    >
      <v-form @submit.prevent="" lazy-validation ref="compensationDialog">
        <v-card-text>
          <v-text-field
            type="number"
            :step="1000"
            v-model="compensationDialog.currentItem.compensation"
            :messages="formatCurrency(compensationDialog.currentItem.compensation, true)"
          ></v-text-field
        ></v-card-text>
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="cancelSheetDialog.isOpen"
      :isOpen="cancelSheetDialog.isOpen"
      :title="cancelSheetDialog.title"
      @close="cancelSheetDialog.isOpen = false"
      @cancel="cancelSheetDialog.onCancel"
      @confirm="cancelSheetDialog.callback"
    >
      <v-form @submit.prevent="" lazy-validation ref="cancelSheetDialog">
        <v-card-text>
          <v-text-field
            label="Lí do"
            v-model="cancelSheetDialog.currentItem.description"
            :rules="[$rules.required]"
          ></v-text-field
        ></v-card-text>
      </v-form>
    </BaseDialog>
    <BaseDialog
      primaryText="Close"
      :hideSecondaryBtn="true"
      v-if="historyDialog.isOpen"
      :isOpen="historyDialog.isOpen"
      :title="historyDialog.title"
      @close="historyDialog.isOpen = false"
      @cancel="historyDialog.onCancel"
      @confirm="historyDialog.callback"
    >
      <v-card-text class="pt-4">
        <div v-for="l in historyDialog.currentItem.logs || []" :key="l.createdAt">
          <span>
            {{ formatDateTime(l.createdAt) }}
            :
          </span>
          <span>
            {{ l.title }} <template v-if="l.description"> ({{ l.description }}) </template>
          </span>
        </div>
      </v-card-text>
    </BaseDialog>
    <v-dialog
      overlay-opacity="0.8"
      content-class="qrcode-dialog"
      :value="activeQrUrl"
      @click:outside="activeQrUrl = ''"
    >
      <img class="qrcode-img fullscreen" :src="getImgUrl(activeQrUrl)" />
    </v-dialog>
  </div>
</template>
<script setup lang="ts">
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader'

import moment from 'moment'
import Breadcrumbs from '@/components/basic/Breadcrumbs.vue'
import DataTableEmpty from '@/components/DataTableEmpty.vue'
import BaseDialog from '@/components/base/BaseDialog'
import DateSelector from '@/components/basic/DateSelector.vue'
import { mapState, mapActions } from 'vuex'
import {
  formatStartDateForAccountSheet,
  transformDateForDatePicker,
  formatDate,
  getDayLabel,
  formatCurrency,
  getImgUrl,
  formatDateTime
} from '@/helpers'
import { get, cloneDeep, sortBy } from 'lodash'
import { mapGetters } from 'vuex/dist/vuex.common.js'
import { saveAs } from 'file-saver'
import XLSX from 'xlsx'
import { Class } from '../../../plugins/api'
import { sumBy } from 'lodash'

export default {
  components: { BaseTableSkeletonLoader, DateSelector, Breadcrumbs, DataTableEmpty, BaseDialog },
  methods: {
    ...mapActions('accountsheet', [
      'fetchAccountSheet',
      'recalculateContent',
      'fetchAccountSheetRowGroups',
      'updateAccountSheet',
      'removeAccountSheet',
      'createManyAccountSheetRows',
      'updateAccountSheetRow',
      'publishAccountSheet',
      'cancelAccountSheet',
      'updateAccountSheetRowGroup'
    ]),
    ...mapActions('course', ['fetchCourses']),
    ...mapActions('staff', ['fetchStaffs']),
    ...mapActions('accountant', ['fetchAccountants']),

    get,
    getImgUrl,
    formatDateTime,
    viewHistory() {
      if (!this.accountSheetData) {
        return
      }
      const logs = this.accountSheetData.logs || []
      logs.unshift({
        title: `Khởi tạo giảng phí`,
        createdAt: this.accountSheetData.createdAt
      })
      this.historyDialog.currentItem = { logs }
      this.historyDialog.isOpen = true
    },
    async onCancel() {
      this.cancelSheetDialog.currentItem = { description: '' }
      this.cancelSheetDialog.title = 'Thu hồi giảng phí'
      this.cancelSheetDialog.isOpen = true
      this.cancelSheetDialog.callback = (async () => {
        if (this.$refs.cancelSheetDialog.validate()) {
          try {
            this.changingState = true
            await this.cancelAccountSheet({
              accountsheetId: this.sheetId,
              data: { description: this.cancelSheetDialog.currentItem.description }
            })
            this.$alert.success('Thu hồi giảng phí thành công')
            this.fetchAccountSheet({ accountsheetId: this.sheetId })
          } catch (error) {
            console.error(error)
            this.$alert.error('Có lỗi xay ra')
          } finally {
            this.cancelSheetDialog.isOpen = false
            this.changingState = false
          }
        }
      }).bind(this)
    },
    onClickQrcode(url) {
      if (!url) {
        return
      }
      this.activeQrUrl = url
    },
    onToggleHeader(key, value) {
      this.headers = this.headers.map(i => {
        if (i.value === key) {
          return { ...i, show: value }
        }
        return i
      })
    },
    async onClickRecalculateContent() {
      if (!this.accountSheetData) {
        return
      }
      try {
        this.isRecalculating = true
        // if (!this.accountSheetData.isPublished && !this.accountSheetRowGroups.length) {
        //   await this.fetchAccountSheetContent({ accountsheetId: this.sheetId })
        // } else {
        //   await this.recalculateContent({ accountsheetId: this.sheetId })
        //   this.fetchAccountSheetContent({ accountsheetId: this.sheetId })
        // }
        await this.recalculateContent({ accountsheetId: this.sheetId })

        this.$alert.success('Tính toán lại hoàn tất')
      } catch (error) {
        console.error(error)
      } finally {
        this.isRecalculating = false
      }
    },
    async refresh() {
      try {
        this.isLoading = true
        await Promise.all([
          this.fetchAccountSheet({ accountsheetId: this.sheetId }),
          this.fetchAccountSheetRowGroups({ accountsheetId: this.sheetId })
          // this.fetchAccountSheetContent({ accountsheetId: this.sheetId })
        ])
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    formatCurrency,
    onClickExport() {
      if (!(this.tableData || {}).length) {
        this.$alert.error('Không có dữ liệu để xuất Excel')
        return
      }
      const tableElm = document.getElementById('content-table')
      if (!tableElm) {
        return
      }
      this.exporting = true
      try {
        const ws = XLSX.utils.table_to_sheet(tableElm, {})
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws)
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(blob, `${this.accountSheetData.title}_${moment().format('YYYY-MM-DD[T]HH:mm')}.xlsx`)
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xả ra')
      } finally {
        this.exporting = false
      }
    },

    async onEditRowNote(id, currentVal = '') {
      this.noteDialog.currentItem = { note: currentVal }
      this.noteDialog.isOpen = true
      this.noteDialog.callback = (async () => {
        try {
          await this.updateAccountSheetRow({ id, note: this.noteDialog.currentItem.note || null })
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.noteDialog.isOpen = false
        }
      }).bind(this)
    },
    async onEditCompensation(id, currentVal = undefined) {
      this.compensationDialog.currentItem = { compensation: currentVal }
      this.compensationDialog.isOpen = true
      this.compensationDialog.callback = (async () => {
        try {
          await this.updateAccountSheetRowGroup({
            id,
            compensation: this.compensationDialog.currentItem.compensation
          })
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.compensationDialog.isOpen = false
        }
      }).bind(this)
    },
    async changeConfirmation(id, v) {
      await this.updateAccountSheetRow({
        id,
        confirmation: v
      })
      this.$alert.success('Cập nhật thành công')
    },
    async onLock() {
      try {
        this.changingState = true
        await this.updateAccountSheet({ id: this.sheetId, isLock: true, lastLockedAt: new Date() })
        this.$alert.success('Khóa thành công')
      } catch (error) {
        console.error(error)
      } finally {
        this.changingState = false
      }
    },
    async onUnLock() {
      try {
        this.changingState = true
        await this.updateAccountSheet({ id: this.sheetId, isLock: false })
        this.$alert.success('Mở khóa thành công')
      } catch (error) {
      } finally {
        this.changingState = false
      }
    },
    async onPublish() {
      // const createAccountSheetRows = (async () => {
      //   const payload = this.tableData
      //     .map(({ index, teacher, slots, ...o }) =>
      //       slots.map(s => ({
      //         ...o,
      //         teacher: teacher.id,
      //         class: s.class.id,
      //         slots: s.slots.map(i => i.id),
      //         account_sheet: this.sheetId
      //       }))
      //     )
      //     .flat()

      //   await this.createManyAccountSheetRows({ data: payload })
      //   this.$alert.success('Xuất bản thành công')
      // }).bind(this)
      // await Promise.all([
      //   this.updateAccountSheet({ id: this.sheetId, isPublished: true }),
      //   createAccountSheetRows()
      // ])
      try {
        this.changingState = true
        await this.publishAccountSheet({ accountsheetId: this.sheetId })
        this.$alert.success('Xuất bản thành công')
        // this.fetchAccountSheet({ accountsheetId: this.sheetId })
      } catch (error) {
        console.error(error)
      } finally {
        this.changingState = false
      }
    },
    getSlotCount(item) {
      return item.account_sheet_rows.map(i => i.slots).flat().length
    },
    getPayCheck(item) {
      const slotCount = this.getSlotCount(item)
      // const rate = (item.teacher.metadata || {}).rate
      const rate = item.rate
      if (!rate) {
        return null
      }
      return rate * slotCount + (item.compensation || 0)
    },
    sortSlots(slots) {
      return sortBy(slots, i => moment(i.startTime).unix())
    },
    formatStartDateForAccountSheet,
    transformDateForDatePicker,
    formatDate,
    getDayLabel,
    formatSlotListText(list) {
      const output = list.map(i => this.formatSlotLabel(i.startTime, i.endTime))
      return output.join('\n')
    },
    formatSlotLabel(startTime, endTime) {
      return `${getDayLabel(startTime)}, ${moment(startTime).format('DD/MM/YYYY HH:mm')} - ${moment(
        endTime
      ).format('HH:mm')}`
    },

    onStartDateChange(value) {
      this.upsertAccountSheetDialog.currentItem.startDate = moment(
        value,
        'YYYY-MM-DD'
      ).toISOString()
    },
    onEndDateChange(value) {
      this.upsertAccountSheetDialog.currentItem.endDate = moment(value, 'YYYY-MM-DD')
        .endOf('day')
        .toISOString()
    },
    onClickUpsertAccountSheet(item) {
      this.upsertAccountSheetDialog.currentItem = item
        ? {
            ...cloneDeep(item),

            startDate: moment(item.startDate).startOf('month').toISOString(),
            endDate: moment(item.endDate).endOf('month').toISOString(),
            note: (item || {}).note
          }
        : {
            title: 'Giảng phí tháng ' + new Date().getMonth(),
            startDate: moment().startOf('month').toISOString(),
            endDate: moment().endOf('month').toISOString()
          }
      this.upsertAccountSheetDialog.title = item ? 'Sửa giảng phí' : 'Tạo giảng phí'
      this.upsertAccountSheetDialog.isOpen = true
      this.upsertAccountSheetDialog.callback = (async () => {
        if (this.$refs.upsertAccountSheetDialog.validate()) {
          try {
            this.upsertAccountSheetDialog.loading = true
            if (item) {
              const payload = cloneDeep(this.upsertAccountSheetDialog.currentItem)
              delete payload.account_sheet_rows
              await this.updateAccountSheet(payload)
              if (!this.accountSheetData.isLock) {
                await this.onClickRecalculateContent()
              }
              this.$alert.success('Cập nhật thành công')
            } else {
              await this.createAccountSheet({
                data: this.upsertAccountSheetDialog.currentItem
              })
              this.$alert.success('Tạo thành công')
            }
          } catch (error) {
            console.error(error)
            this.$alert.error('Có lỗi xay ra')
          } finally {
            this.upsertAccountSheetDialog.isOpen = false
            this.upsertAccountSheetDialog.loading = false
          }
        }
      }).bind(this)
    },

    onClickDeleteAccountSheet(item) {
      this.$dialog.confirm({
        title: 'Xóa bảng điểm',
        text: ` Bạn có Chắc Chắn xóa giảng phí và các thông tin liên quan?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeAccountSheet(item.id)
          this.$alert.success('Xóa thành công')
          this.$router.push('/account-sheets')
        }
      })
    },
    getCourseLabel(id) {
      const match = this.courses[id]
      if (!match) {
        return null
      }
      return match.title
    },
    getStatusText(item) {
      if (item.isCanceled) return 'Đã thu hồi'
      if (item.isLock) return 'Đã khóa'
      if (item.isPublished) return 'Đã xuất bản'
      return 'Nháp'
    }
  },
  computed: {
    ...mapState('accountsheet', ['accountSheets', 'accountSheetContents', 'accountSheetRowGroups']),
    ...mapState('course', ['courses']),
    ...mapGetters('auth', ['role']),

    ...mapState('staff', ['staffs']),
    ...mapState('accountant', ['accountants']),
    ...mapState('app', ['department', 'roles']),
    allHidableHided() {
      const output = this.hidableColumns.every(i => !(this.headerVisibilityStatus[i] || {}).show)
      return output
    },
    contactAccountantText() {
      if (!this.accountSheetData) {
        return ''
      }
      const accountant = this.accountSheetData.accountant
      if (!accountant) {
        return ''
      }

      return `${accountant.name} (${accountant.phone})`
    },
    headerGroup1() {
      return this.headers.slice(0, 6)
    },
    headerGroup2() {
      return this.headers.slice(-5)
    },
    headerGroup3() {
      return this.headers.slice(6, -5)
    },
    headerVisibilityStatus() {
      return Object.fromEntries(
        this.headers
          .map(({ show, text, value }) =>
            this.hidableColumns.includes(value) ? [value, { show, text }] : undefined
          )
          .filter(Boolean)
      )
    },
    sheetStatusText() {
      if (!this.accountSheetData) {
        return ''
      }
      return this.getStatusText(this.accountSheetData)
    },
    isSuperOrAccountant() {
      if (!this.role) {
        return false
      }
      return ['super_admin', 'accountant'].includes(this.role.type)
    },
    dateRangeText() {
      if (!this.accountSheetData) {
        return ''
      }
      const { startDate, endDate } = this.accountSheetData
      return `${formatDate(startDate)} - ${formatDate(endDate)}`
    },
    sheetId() {
      return this.$route.params['id']
    },
    accountSheetData() {
      return this.accountSheets.find(i => i.id === this.sheetId)
    },
    // sheetContent() {
    //   return this.accountSheetContents.find(i => i.id === this.sheetId)
    // },
    // sheetRowsGroupedByTeacher() {
    //   return this.accountSheetRowGroups.reduce((p, c) => {
    //     const match = p.find(i => i.teacher.id === c.teacher.id)
    //     const {
    //       id,
    //       teacher,
    //       account_sheet_rows,
    //       class: $class,
    //       account_sheet,
    //       note,
    //       confirmation,
    //       ...o
    //     } = c
    //     if (!match) {
    //       return [
    //         ...p,
    //         {
    //           ...o,
    //           teacher,
    //           account_sheet_rows: [
    //             {
    //               class: $class,
    //               slots: slots.map(j => ({ startTime: j.startTime, endTime: j.endTime, id: j.id })),
    //               id,
    //               note,
    //               confirmation
    //             }
    //           ]
    //         }
    //       ]
    //     }
    //     const clonedMatch = cloneDeep(match)
    //     clonedMatch.slots.push({
    //       note,
    //       confirmation,
    //       id,
    //       class: $class,
    //       slots: slots.map(j => ({ startTime: j.startTime, endTime: j.endTime, id: j.id }))
    //     })
    //     return p.map(i => (i.teacher.id === clonedMatch.teacher.id ? clonedMatch : i))
    //   }, [])
    // },
    tableData() {
      if (!this.accountSheetData) {
        return []
      }
      // let output
      // if (this.accountSheetData.isPublished) {
      //   output = this.accountSheetRowGroups
      // } else {
      //   output = this.sheetContent.data
      // }
      const output = this.accountSheetRowGroups

      return output
        .filter(({ teacher }) => {
          if (!this.search) {
            return true
          }
          let regex = new RegExp(this.search.replace(/\s+/g, ' ').trim(), 'i')
          if (teacher.name.match(regex)) {
            return true
          }
          return false
        })
        .map((i, id) => ({ ...i, index: id + 1 }))
    },
    totalPayCheck() {
      if (!this.tableData.length) {
        return 0
      }
      const output = sumBy(this.tableData.map(i => this.getPayCheck(i)))
      return output
    },
    totalCompensation() {
      if (!this.tableData.length) {
        return 0
      }
      const output = sumBy(this.tableData.map(i => i.compensation || 0))
      return output
    },
    totalSlotCount() {
      if (!this.tableData.length) {
        return 0
      }
      const output = sumBy(this.tableData.map(i => this.getSlotCount(i)))
      return output
    },

    isEmpty() {
      return !this.tableData.length
    },
    sheetInfo() {
      if (!this.accountSheetData) {
        return []
      }
      const output = [
        {
          label: 'Bắt đầu',
          value: this.formatStartDateForAccountSheet(this.accountSheetData.startDate)
        },
        {
          label: 'Kết thúc',
          value: this.formatDate(this.accountSheetData.endDate)
        }
      ]

      return output
    }
  },
  data() {
    return {
      changingState: false,
      showingDetailColumns: false,
      activeQrUrl: '',
      isLoading: false,
      isRecalculating: false,
      exporting: false,
      noteDialog: {
        currentItem: null,
        isOpen: false,
        title: 'Ghi chú',
        onCancel: () => {
          this.noteDialog.isOpen = false
        },
        callback: () => {}
      },
      historyDialog: {
        currentItem: null,
        isOpen: false,
        title: 'Lịch sử',
        onCancel: () => {
          this.historyDialog.isOpen = false
        },
        callback: () => {
          this.historyDialog.isOpen = false
        }
      },
      compensationDialog: {
        currentItem: null,
        isOpen: false,
        title: 'Khoản khác',
        onCancel: () => {
          this.compensationDialog.isOpen = false
        },
        callback: () => {}
      },
      upsertAccountSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.upsertAccountSheetDialog.isOpen = false
        },
        callback: () => {},
        loading: false
      },
      cancelSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.cancelSheetDialog.isOpen = false
        },
        callback: () => {}
      },
      search: '',
      moneyRelatedColumns: ['rate', 'compensation', 'payCheck'],
      hidableColumns: ['bankName', 'bankNumber', 'teacher.qrcode.url', 'email', 'phone'],
      headers: [
        { text: 'STT', class: 'column-index', align: 'center', value: 'index', show: true },
        {
          class: 'column-name font-weight-bold',
          text: 'Giáo viên',
          align: 'center',
          value: 'teacher.name',
          show: true
        },
        {
          class: 'column-rate',
          text: 'Giảng phí',
          align: 'center',
          value: 'rate',
          show: true
        },
        {
          class: 'column-total-slot-count font-weight-bold',
          text: 'Tổng Số buổi',
          align: 'center',
          value: 'totalSlotCount',
          show: true
        },
        {
          class: 'column-compensation',
          text: 'Khoản khác',
          align: 'center',
          value: 'compensation',
          show: true
        },
        {
          class: 'column-paycheck font-weight-bold',
          text: 'Tổng tiền',
          align: 'center',
          value: 'payCheck',
          show: true
        },
        { class: 'column-course', text: 'Môn học', align: 'center', value: 'course', show: true },
        { class: 'column-class', text: 'Lớp', align: 'center', value: 'class', show: true },
        {
          class: 'column-slot-count',
          text: 'Số buổi',
          align: 'center',
          value: 'slotCount',
          show: true
        },
        { class: 'column-slots', text: 'Ngày dạy', align: 'center', value: 'slots', show: true },
        {
          class: 'column-note',
          text: 'Ghi chú',
          align: 'center',
          value: 'note',
          show: true
        },
        {
          class: 'column-bank-name',
          text: 'Tên ngân hàng',
          align: 'center',
          value: 'bankName',
          show: false
        },
        {
          class: 'column-bank-number',
          text: 'STK',
          align: 'center',
          value: 'bankNumber',
          show: false
        },

        {
          class: 'column-qrcode',
          text: 'Mã QR',
          align: 'center',
          value: 'teacher.qrcode.url',
          show: false
        },
        {
          class: 'column-email',
          text: 'Email',
          align: 'center',
          value: 'email',
          show: false
        },
        {
          class: 'column-phone',
          text: 'SĐT',
          align: 'center',
          value: 'phone',
          show: false
        }
      ]
    }
  },
  async created() {
    await Promise.all([this.fetchCourses({ _limit: -1 }), this.fetchAccountants(), this.refresh()])
  }
}
</script>
<style scoped lang="scss">
/* .sheet-info {
  display: grid;
  grid-template-columns: 2; */
/* } */
@import '~vuetify/src/styles/styles.sass';
::v-deep {
  --column-index-width: 52px;
  --column-name-width: 100px;
  --column-detail-width: 840px;
  --column-bank-name-width: 120px;
  --column-bank-number-width: 120px;
  --column-qrcode-width: 160px;
  --column-rate-width: 90px;
  --column-phone-width: 120px;
  --column-email-width: 220px;
  --column-course-min-width: 120px;
  --column-class-min-width: 140px;
  --column-slot-count-min-width: 60px;
  --column-slots-width: 240px;
  --column-total-slot-count-width: 60px;
  --column-paycheck-width: 120px;
  --column-note-width: 200px;
  --column-compensation-width: 90px;
  --column-confirmation-width: 60px;
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    // .column-index {
    //   width: 60px;
    // }

    // td:nth-child(2) {
    //   left: 60px;
    // }

    --column-index-width: 60px;
    --column-name-width: 160px;
    --column-course-width: 160px;
    --column-class-width: 160px;
    --column-phone-width: 140px;
    --column-bank-name-width: 140px;
    --column-bank-number-width: 140px;
    --column-rate-width: 140px;
    --column-paycheck-width: 140px;
    // tbody tr.summary-row:last-child td:nth-child(2) {
    //   left: 220px;
    // }
  }
  .qrcode-dialog {
    box-shadow: none !important;
    width: fit-content;
  }
  thead tr:first-child th:not([colspan]),
  thead tr:nth-child(2) th {
    background-color: rgb(42, 99, 255) !important;
    color: white !important;
    font-weight: 400;
  }
  thead tr:first-child th[colspan] {
    background: orange !important;
    color: white !important;
    font-weight: 400;
  }

  tr {
    background-color: white !important;
  }
  th,
  td {
    background-color: #fff;
  }

  .column-index {
    width: var(--column-index-width);
  }
  .column-name {
    width: var(--column-name-width);
  }
  .column-detail {
    width: var(--column-detail-width);
  }
  .column-bank-name {
    width: var(--column-bank-name-width);
  }
  .column-bank-number {
    width: var(--column-bank-number-width);
  }
  .column-qrcode {
    width: var(--column-qrcode-width);
  }
  .column-rate {
    width: var(--column-rate-width);
  }
  .column-phone {
    width: var(--column-phone-width);
  }
  .column-email {
    width: var(--column-email-width);
  }
  .column-course {
    min-width: var(--column-course-min-width);
  }
  .column-class {
    min-width: var(--column-class-min-width);
  }
  .column-slot-count {
    min-width: var(--column-slot-count-min-width);
  }
  .column-slots {
    width: var(--column-slots-width);
  }
  .column-total-slot-count {
    width: var(--column-total-slot-count-width);
  }
  .column-paycheck {
    width: var(--column-paycheck-width);
  }
  .column-note {
    width: var(--column-note-width);
  }
  .column-compensation {
    width: var(--column-compensation-width);
  }
  .column-confirmation {
    width: var(--column-confirmation-width);
  }
  .v-data-table__wrapper thead th {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: #dddddd !important;
  }

  thead tr:nth-child(1) th:first-child {
    border-left-width: 0 !important;
  }
  table tr:not(.child-row) td:not(:first-child) {
    border-left: 1px solid #dddddd;
  }

  table tr.child-row td {
    border-left: 1px solid #dddddd;
  }
  tr:first-child th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  tr:nth-child(2) th {
    position: sticky;
    top: 32px;
    z-index: 1;
  }
  #content-table {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 150px);
  }
  .v-data-table__wrapper {
    overflow-x: auto;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
      background: #e1e1e1;
      &:horizontal {
        height: 12px;
      }
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      width: 6px;
      background-color: #a5a5a5;
      border: 1px solid #e1e1e1;
      &:horizontal {
        border-radius: 6px;

        height: 12px;
      }
    }
  }
  table {
    table-layout: fixed;
  }
  th:first-child,
  td:first-child {
    left: 0;
  }
  th:nth-child(2),
  td:nth-child(2) {
    left: var(--column-index-width);
  }
  tr:first-child {
    th:nth-child(-n + 2) {
      position: sticky;
      z-index: 2;
    }
  }
  tr:not(.child-row) td:nth-child(-n + 2) {
    position: sticky;
    z-index: 1;
  }
  // tbody tr.summary-row:last-child td:nth-child(2) {
  //   position: static;
  // }
  tr.summary-row:last-child {
    td:nth-child(2) {
      left: calc(var(--column-index-width) + var(--column-name-width) + var(--column-rate-width));
      position: sticky;
      z-index: inherit;
    }
    td:nth-child(3) {
      left: calc(
        var(--column-index-width) + var(--column-name-width) + var(--column-rate-width) +
          var(--column-total-slot-count-width)
      );
      position: sticky;
      z-index: inherit;
    }
    td:nth-child(4) {
      left: calc(
        var(--column-index-width) + var(--column-name-width) + var(--column-rate-width) +
          var(--column-total-slot-count-width) + var(--column-compensation-width)
      );
      position: sticky;
      z-index: inherit;
    }
  }
  .cell-note {
    text-align: center;
  }
  .cell-index {
    text-align: center;
  }
  .cell-qrcode {
    text-align: center;
  }
  .cell-confirmation {
    text-align: center;
  }
  .cell-slot-count {
    text-align: center;
  }
  .cell-total-slot-count {
    text-align: center;
  }
  .cell-rate {
    text-align: center;
  }
  .cell-paycheck,
  .cell-compensation {
    text-align: center;
  }
  .cell-class {
    word-break: normal;
  }

  .summary-row td {
    font-weight: bold;
    font-size: 1rem !important;
  }
  .table-layout-auto table {
    table-layout: auto;
    th,
    td {
      width: auto !important;
      left: unset !important;
    }
  }
}
.note-wrapper,
.compensation-wrapper {
  cursor: pointer;
}
.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  &.fullscreen {
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      max-width: 400px;
      max-height: 400px;
    }
    max-width: 90vw;
    max-height: 90vh;

    width: auto;
    height: auto;
    display: block;
    margin: auto;
  }
}
</style>
